import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { thunderstormATSGroups } from '../../consts.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { LL_V_L } from '../Layouts/index.js';
import { TS_AppTools } from '../TS_AppTools/index.js';
import './ATS_CheckboxGroup.scss';
import { TS_CheckboxGroup } from "./TS_CheckboxGroup.js";
import { voidFunction } from "@nu-art/ts-common";
export class ATS_CheckboxGroup extends ComponentSync {
    static Screen = {
        key: 'ats-ts-checkbox-group',
        name: 'CheckboxGroup',
        group: thunderstormATSGroups,
        renderer: this,
    };
    deriveStateFromProps(nextProps, state) {
        state.selectedIdsGroup ??= [];
        state.selectedIdsSomeDisabled ??= [];
        return state;
    }
    //######################### Logic #########################
    onChangeGroup = (selectedIds) => {
        this.setState({ selectedIdsGroup: selectedIds });
    };
    onChangeSomeDisabledGroup = (selectedIds) => {
        this.setState({ selectedIdsSomeDisabled: selectedIds });
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { id: 'ats__checkboxGroup', children: [TS_AppTools.renderPageHeader('Checkbox Group'), this.render_CheckboxGroup(), this.render_PartialDisabledCheckboxGroup(), this.render_DisabledParent()] });
    }
    render_CheckboxGroup = () => {
        const options = [
            {
                id: '1',
                label: 'first',
            },
            {
                id: '2',
                label: 'second',
            },
            {
                id: '3',
                label: 'third',
            }
        ];
        return _jsx(TS_CheckboxGroup, { parent: { id: 'father', label: 'all' }, options: options, onChange: this.onChangeGroup, selectedIds: this.state.selectedIdsGroup });
    };
    render_PartialDisabledCheckboxGroup = () => {
        const options = [
            {
                id: '1',
                label: 'Disabled',
                disabled: true,
            },
            {
                id: '2',
                label: 'Not Disabled',
            },
            {
                id: '3',
                label: 'Disabled 2',
                disabled: true,
            },
            {
                id: '4',
                label: 'Not Disabled 2',
            }
        ];
        return _jsx(TS_CheckboxGroup, { parent: { id: 'father', label: 'All' }, options: options, onChange: this.onChangeSomeDisabledGroup, selectedIds: this.state.selectedIdsSomeDisabled });
    };
    render_DisabledParent = () => {
        const options = [
            {
                id: '1',
                label: 'Not Disabled 1',
            },
            {
                id: '2',
                label: 'Not Disabled 2',
            },
            {
                id: '3',
                label: 'Not Disabled 3',
            }
        ];
        return _jsx(TS_CheckboxGroup, { parent: { id: 'father', label: 'Disabled Father', disabled: true }, options: options, onChange: voidFunction, selectedIds: [] });
    };
}
//# sourceMappingURL=ATS_CheckboxGroup.js.map